/**
 * PreauthView - Invisible page used for background pre-authentication.
 *
 * Loaded as a hidden iframe by the parent app (Izzi) when the dispute dialog
 * opens. Auth runs automatically via AuthContext (ssoSilent or AUTH_TOKEN
 * handshake). On success, MSAL caches tokens to localStorage so that the
 * subsequent ticket embed iframe can skip the auth round-trip.
 *
 * Route: /preauth
 */
const PreauthView = () => null

export default PreauthView
